module.exports = __webpack_public_path__ + "c93c5168cdeaa7933ef13e83a38933ab.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/profile-picture.jpg
 ** module id = 743
 ** module chunks = 0
 **/